import { Button, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import {
  getAdminServicePermissionsList,
  batchCreateResource,
} from '../../../api';
import { messageError, messageSuccess } from '../../../components/message';
import warnImage from '../../../assets/images/warn-yellow.png';
import { IPermissionResourceType } from '../../../model/api-modules';
import { SvgIcon } from '../../component/svg-icon';
import { SvgIconName } from '../../component/svg-icon/model';
// import { DownLoadDrawer } from './download-drawer';
// import { DownloadTable } from './lib/download-table';
import { ModalWrap } from '../../component/modal-wrap';
import { ReloadOutlined } from '@ant-design/icons';
import getFormatMessage from '../../../locales/get-format-message';
import { GroupTable } from './lib/group-table';
import { deleteResourceGroup } from '../../../api/admin/permission';
import { GroupDrawer } from './lib/group-drawer';
import { IServicePermissionsGroupItem } from '../../../model';
import { ReactJsonEditor } from '../../../components/react-json-editor';
import { IJsonEditorError } from '../../../components/json-editor/model';
import { LINE_FORM_LAYOUT } from '../app-config/lib/form';
import { wrapRequestArea } from '../../../lib/http/lib';

interface IProps {
  readonly setListReload: (value: boolean) => void;
  readonly listReload: boolean;
  readonly site?: string;
}

export const GroupItemsComponent = (props: IProps) => {
  const { site } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [groupList, setGroupList] = useState<
    IServicePermissionsGroupItem[] | []
  >([]);
  const [row, setRow] = useState<IServicePermissionsGroupItem | null>(null);
  const [editType, setEditType] = useState<IPermissionResourceType>();
  const [delRow, setDelRow] = useState<IServicePermissionsGroupItem | null>(
    null
  );
  const [showJsonModal, setShowJsonModal] = useState<boolean>(false);
  const [customError, setCustomError] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [resError, setResError] = useState<string>('');
  const [form] = useForm<any>();
  // const [shouldUpdate, setShouldUpdate] = useState(false);

  const initJson = {
    data: [
      {
        groupName: '',
        groups: [
          {
            groups: [
              {
                groupName: '',
                newGroupName: '',
                objects: [
                  {
                    key: '',
                    name: '',
                    syncRoleType: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };

  const getGroupList = async () => {
    setLoading(true);
    const res = await wrapRequestArea(getAdminServicePermissionsList, site);
    console.log('getServicePermissionsList-res:', res);
    if (res) {
      setGroupList(res.objectGroup);
    } else {
      messageError(getFormatMessage('group_list_fail'));
    }
    setLoading(false);
  };
  const onDel = (record: IServicePermissionsGroupItem) => {
    setDelRow(record);
  };
  const onEdit = (record: IServicePermissionsGroupItem) => {
    setRow(record);
    setEditType(IPermissionResourceType.Edit);
  };
  const onAdd = () => {
    setEditType(IPermissionResourceType.Create);
  };
  const onClose = (success?: boolean) => {
    setRow(null);
    setDelRow(null);
    setEditType(undefined);
    if (success) {
      getGroupList();
    }
  };

  const confirmDel = async () => {
    if (delRow) {
      const res = await deleteResourceGroup([delRow.objectGroupId]);
      if (res.code === 0) {
        messageSuccess(getFormatMessage('del_success'));
        getGroupList();
        onClose(true);
        return true;
      }
      messageError(getFormatMessage('error_delete'));
    }
    messageError(getFormatMessage('error_delete'));
    return false;
  };

  const renderDelModal = () => {
    if (delRow) {
      const name = delRow.objectGroupName;
      return (
        <ModalWrap
          onOk={confirmDel}
          onClose={() => onClose(false)}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('delete')}
          width="480px"
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('delete_group')}</span>
            </p>
          }
          className="delete-modal"
        >
          <div>
            {getFormatMessage('del_group_sure_desc')}
            {name}?
          </div>
        </ModalWrap>
      );
    }
    return null;
  };
  useEffect(() => {
    getGroupList();
  }, []);

  const onBatchAdd = () => {
    setShowJsonModal(true);
  };

  const onBatchClose = () => {
    setCustomError('');
    setError(false);
    setResError('');
    form.setFieldValue('JsonConfig', '');
    setShowJsonModal(false);
  };

  const onError = (error: IJsonEditorError | false) => {
    setError(!!error);
  };

  const onJsonChange = (json?: Object) => {
    form.setFieldValue('JsonConfig', JSON.stringify(json) || '');
  };

  const onSubmit = async () => {
    if (error) {
      console.error(getFormatMessage('json_config_error'));
      return false;
    }

    // await jsonValidator().catch((e) => {
    //   setCustomError(e);
    // });

    setCustomError('');
    setLoading(true);

    let values = null;
    try {
      values = await form.validateFields();
    } catch (error) {
      console.error(getFormatMessage('validate_error'), error);
    }

    if (values) {
      const params = JSON.parse(values.JsonConfig || JSON.stringify(initJson));
      const res = await batchCreateResource(params);
      setLoading(false);
      if (res) {
        // 有部分成功部分失败的情况 接口成功先去更新list
        getGroupList();
        // 更新object列表
        props.setListReload(!props.listReload);
        if (
          res?.error?.groups?.length !== 0 ||
          res?.error?.groups?.length !== 0 ||
          res?.error?.rbacPermSync?.length !== 0
        ) {
          messageError(getFormatMessage('create_fail'));
          const resErrorData = {
            error: res?.error || {},
          };
          setResError(JSON.stringify(resErrorData));
          return false;
        }
        messageSuccess(getFormatMessage('create_success'));
        onBatchClose();
        return true;
      }
    }
    return false;
  };

  const renderCustomError = () => {
    if (!customError) return null;
    return (
      <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
        <div
          id="JsonConfig_help"
          className="ant-form-item-explain ant-form-item-explain-connected"
          role="alert"
        >
          <div className="ant-form-item-explain-error">{customError}</div>
        </div>
      </div>
    );
  };

  const renderGroupDrawer = () => {
    if (editType) {
      const editRow = editType === IPermissionResourceType.Edit ? row : null;
      return <GroupDrawer row={editRow} onClose={onClose} type={editType} />;
    }
    return null;
  };

  const renderJsonModal = () => {
    if (showJsonModal) {
      return (
        <ModalWrap
          onOk={onSubmit}
          onClose={onBatchClose}
          cancelText={
            resError ? getFormatMessage('close') : getFormatMessage('cancel')
          }
          oKText={resError ? '' : getFormatMessage('submit')}
          width="880px"
          title={getFormatMessage('batch_create_resources')}
          loading={loading}
        >
          {resError ? (
            <>
              <div style={{ color: '#ff4d4f', marginBottom: 8 }}>
                {getFormatMessage('batch_create_faild')}
              </div>
              <ReactJsonEditor
                onError={onError}
                // onChange={onJsonChange}
                id="app-config-json-editor"
                height={550}
                json={JSON.parse(resError || '{"error": {}}')}
              />
              {renderCustomError()}
            </>
          ) : (
            <Form form={form}>
              <Form.Item
                {...LINE_FORM_LAYOUT}
                // rules={[{ required: true }, { validator: jsonValidator }]}
                labelAlign="right"
                name="JsonConfig"
              >
                <ReactJsonEditor
                  onError={onError}
                  onChange={onJsonChange}
                  id="app-config-json-editor"
                  height={550}
                  json={JSON.parse(
                    form.getFieldValue('JsonConfig') || JSON.stringify(initJson)
                  )}
                />
                {renderCustomError()}
              </Form.Item>
            </Form>
          )}
        </ModalWrap>
      );
    }
    return null;
  };

  return (
    <>
      <div className="admin-page-title webkit-box flex-space-between">
        <div className="page-title-left">
          <Button
            className="gc-btn-download gc-btn gc-btn-primary"
            onClick={onAdd}
            style={{ marginTop: 24, marginBottom: 12 }}
            icon={
              <SvgIcon
                className="in-game-ant-icon"
                icon={SvgIconName.InviteAddIcon}
              />
            }
          >
            {getFormatMessage('create_group')}
          </Button>
          <Button
            className="gc-btn-download gc-btn gc-btn-primary"
            onClick={onBatchAdd}
            style={{ margin: '24px 0 12px 12px' }}
            icon={
              <SvgIcon
                className="in-game-ant-icon"
                icon={SvgIconName.InviteAddIcon}
              />
            }
          >
            {getFormatMessage('batch_create_resources')}
          </Button>
        </div>
        <div className="page-title-right">
          <span>{getFormatMessage('list')}</span>
          <ReloadOutlined onClick={getGroupList} className="refresh-icon" />
        </div>
      </div>
      <GroupTable
        getGroupList={getGroupList}
        loading={loading}
        groupList={groupList || []}
        onEdit={onEdit}
        onDel={onDel}
      />
      {renderGroupDrawer()}
      {renderDelModal()}
      {renderJsonModal()}
    </>
  );
};
